import React from "react";
import { Link } from "react-router-dom";
import api from "../../Environment";
import Helper from "../Helper/helper";
import { withToastManager } from "react-toast-notifications";
import ToastDemo from "../Helper/toaster";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import configuration from "react-global-configuration";
import {
  StandalonePageHeader,
  StandalonePageLogo,
} from "../Layouts/SubLayout/StandalonePageLogo";
import { translate } from "react-multi-lang";
import { apiConstants } from "../Constant/constants";
import { getGooglePublicClientId, getFacebookAppId, loadAuthConfig } from "../../auth/authConfigService";
import GoogleSignInButton from "./GoogleSignInButton";
import DestinationExperienceGate from "../Experience/DestinationExperienceGate";
import {
  mapGoogleJwtToRegisterPayload,
  googleAuthNetworkErrorMessage,
  safeAuthRedirectPath,
} from "./googleAuth";

var const_time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;

class LoginCommponent extends Helper {
  state = {
    data: {
      email: "",
      password: "",
      timezone: const_time_zone, 
    },
    loadingContent: null,
    buttonDisable: false,
    formError: null,
    authProvidersReady: false,
    facebookAppId: "",
    googleClientId: "",
  };

  componentDidMount() {
    // Re-read after App bootstrap; hard refresh can race Auth Providers vs legacy FB id.
    loadAuthConfig({ force: false })
      .catch(function () {
        return null;
      })
      .then(() => {
        this.refreshAuthProviders();
      });
  }

  refreshAuthProviders = () => {
    this.setState({
      authProvidersReady: true,
      facebookAppId: getFacebookAppId() || "",
      googleClientId: getGooglePublicClientId() || "",
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      loadingContent: this.props.t("button_loading"),
      buttonDisable: true,
      formError: null,
    });
    api
      .postMethod("v4/login", this.state.data)
      .then((response) => {
        if (response.data.success) {
          localStorage.setItem("userId", response.data.data.user_id);
          localStorage.setItem("accessToken", response.data.data.token);
          localStorage.setItem("userType", response.data.data.user_type);
          localStorage.setItem("push_status", response.data.data.push_status);
          localStorage.setItem("username", response.data.data.name);
          localStorage.setItem(
            "active_profile_id",
            response.data.data.sub_profile_id
          );
          ToastDemo(this.props.toastManager, response.data.message, "success");
          const redirectTo = safeAuthRedirectPath(
            this.props.location && this.props.location.state,
            "/view-profiles"
          );
          this.props.history.push(redirectTo);
          this.setState({
            loadingContent: null,
            buttonDisable: false,
            formError: null,
          });
        } else {
          const errorText =
            response.data.error_messages ||
            response.data.message ||
            "Login failed. Please check your email and password.";
          ToastDemo(this.props.toastManager, errorText, "error");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
            formError: errorText,
          });
        }
      })
      .catch((error) => {
        const errorText =
          (error &&
            error.response &&
            error.response.data &&
            (error.response.data.error_messages ||
              error.response.data.message)) ||
          (error && error.message) ||
          "Login failed. Please try again.";
        ToastDemo(this.props.toastManager, errorText, "error");
        this.setState({
          loadingContent: null,
          buttonDisable: false,
          formError: errorText,
        });
      });
  };

  responseFacebook = (response) => {
    if (response) {
      if (response.status === "unknown") {
        ToastDemo(this.props.toastManager, "Cancelled", "error");
        return false;
      }
      if (!response.accessToken) {
        const msg = "Facebook access token missing. Please try again.";
        ToastDemo(this.props.toastManager, msg, "error");
        this.setState({ formError: msg });
        return false;
      }
      const emailAddress =
        response.email === undefined || response.email === null
          ? null
          : response.email;

      if (!emailAddress) {
        const msg =
          "Facebook email permission is required. Please allow email access and try again.";
        ToastDemo(this.props.toastManager, msg, "error");
        this.setState({ formError: msg });
        return false;
      }

      const facebookLoginInput = {
        social_unique_id: response.id,
        access_token: response.accessToken,
        login_by: "facebook",
        email: emailAddress,
        name: response.name,
        device_type: "web",
        device_token: apiConstants.DEVICE_TOKEN,
        timezone: const_time_zone,
      };
      api
        .postMethod("v4/register", facebookLoginInput)
        .then((response) => {
          if (response.data.success === true) {
            localStorage.setItem("userId", response.data.data.user_id);
            localStorage.setItem("accessToken", response.data.data.token);
            localStorage.setItem("push_status", response.data.data.push_status);
            localStorage.setItem("userType", response.data.data.user_type);

            localStorage.setItem("username", response.data.data.name);
            localStorage.setItem(
              "active_profile_id",
              response.data.data.sub_profile_id
            );
            ToastDemo(
              this.props.toastManager,
              response.data.message,
              "success"
            );
            this.props.history.push("/view-profiles");
            this.setState({
              loadingContent: null,
              buttonDisable: false,
              formError: null,
            });
          } else {
            const errorText =
              response.data.error_messages ||
              response.data.message ||
              "Facebook sign-in failed.";
            ToastDemo(this.props.toastManager, errorText, "error");
            this.setState({
              loadingContent: null,
              buttonDisable: false,
              formError: errorText,
            });
          }
        })
        .catch((error) => {
          const errorText =
            (error &&
              error.response &&
              error.response.data &&
              (error.response.data.error_messages ||
                error.response.data.message)) ||
            (error && error.message) ||
            "Facebook sign-in failed.";
          ToastDemo(this.props.toastManager, errorText, "error");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
            formError: errorText,
          });
        });
    }
  };

  /**
   * Google Identity Services credential JWT payload (decoded) + raw credential.
   * Maps sub/email/name/picture to the existing v4/register social payload.
   * Raw credential is sent as id_token for server-side verification (LQI-C02).
   */
  responseGoogle = (decoded, idToken) => {
    if (!decoded || !decoded.sub) {
      const msg = "Invalid Google credential. Please try again.";
      ToastDemo(this.props.toastManager, msg, "error");
      this.setState({ formError: msg });
      return;
    }

    if (!idToken || !String(idToken).trim()) {
      const msg = "Google ID token is required for Google sign-in.";
      ToastDemo(this.props.toastManager, msg, "error");
      this.setState({ formError: msg, buttonDisable: false });
      return;
    }

    this.setState({ buttonDisable: true, formError: null });

    let googleLoginInput;
    try {
      googleLoginInput = mapGoogleJwtToRegisterPayload(
        decoded,
        apiConstants.DEVICE_TOKEN,
        const_time_zone,
        idToken
      );
    } catch (mapError) {
      const msg =
        (mapError && mapError.message) ||
        "Google ID token is required for Google sign-in.";
      ToastDemo(this.props.toastManager, msg, "error");
      this.setState({ formError: msg, buttonDisable: false });
      return;
    }

    api
      .postMethod("v4/register", googleLoginInput)
      .then((response) => {
        if (response.data.success === true) {
          localStorage.setItem("userId", response.data.data.user_id);
          localStorage.setItem("accessToken", response.data.data.token);
          localStorage.setItem("userType", response.data.data.user_type);
          localStorage.setItem("push_status", response.data.data.push_status);
          localStorage.setItem("username", response.data.data.name);
          localStorage.setItem(
            "active_profile_id",
            response.data.data.sub_profile_id
          );
          ToastDemo(
            this.props.toastManager,
            response.data.message,
            "success"
          );
          this.props.history.push("/view-profiles");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
            formError: null,
          });
        } else {
          const errorText =
            response.data.error_messages ||
            response.data.message ||
            "Google sign-in failed. Please try again.";
          ToastDemo(this.props.toastManager, errorText, "error");
          this.setState({
            loadingContent: null,
            buttonDisable: false,
            formError: errorText,
          });
        }
      })
      .catch((error) => {
        const errorText = googleAuthNetworkErrorMessage(error);
        ToastDemo(this.props.toastManager, errorText, "error");
        this.setState({
          loadingContent: null,
          buttonDisable: false,
          formError: errorText,
        });
      });
  };

  responseGoogleError = (message) => {
    const msg = message || "Google sign-in was cancelled.";
    ToastDemo(this.props.toastManager, msg, "error");
    this.setState({ formError: msg });
  };

  render() {
    const { t } = this.props;
    var bgImg = {
      backgroundImage: `url(${configuration.get(
        "configData.common_bg_image"
      )})`,
    };
    const { data } = this.state;

    return (
      <DestinationExperienceGate destinationType="login">
      <div>
        <div className="common-bg-img" style={bgImg}>
          <StandalonePageHeader variant="auth">
            <StandalonePageLogo linkTo="/" />
          </StandalonePageHeader>

          <div className="row">
            <div className="col-sm-9 col-md-7 col-lg-5 col-xl-4 auto-margin">
              <div className="register-box">
                <h3 className="register-box-head">{t("signin")}</h3>
                <form onSubmit={this.handleSubmit} className="auth-form login-new-form">
                  {this.state.formError ? (
                    <div
                      className="alert alert-danger"
                      role="alert"
                      style={{ marginBottom: "1rem" }}
                    >
                      {this.state.formError}
                    </div>
                  ) : null}
                  <div className="form-group">
                    <label className="sr-only" htmlFor="email">
                      {t("email_address")}
                    </label>
                    <input
                      type="email"
                      onChange={this.handleChange}
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder={t('enter_email_address')}
                      aria-label={t("email_address")}
                      value={data.email}
                    />
                  </div>
                  <div className="form-group">
                    <label className="sr-only" htmlFor="pwd">
                      {t("password")}
                    </label>
                    <input
                      type="password"
                      onChange={this.handleChange}
                      className="form-control"
                      id="pwd"
                      name="password"
                      placeholder={t('enter_password')}
                      aria-label={t("password")}
                      value={data.password}
                    />
                  </div>
                  <p className="mt-4">
                    <Link to={"/forgot-password"} className="btn-link">
                      {t("forgot_password")}
                    </Link>
                  </p>
                  <button
                    className="btn btn-danger auth-btn"
                    disabled={this.state.buttonDisable}
                  >
                    {this.state.loadingContent != null
                      ? this.state.loadingContent
                      : t("signin")}
                  </button>
                </form>
                <div>
                  {this.state.authProvidersReady && this.state.facebookAppId ? (
                    <FacebookLogin
                      key={"fb-" + this.state.facebookAppId}
                      appId={this.state.facebookAppId}
                      fields="name,email,picture"
                      scope="public_profile,email"
                      callback={this.responseFacebook}
                      disableMobileRedirect={true}
                      isMobile={false}
                      version="18.0"
                      render={(renderProps) => (
                        <button
                          type="button"
                          className="social"
                          onClick={renderProps.onClick}
                          disabled={
                            this.state.buttonDisable || renderProps.disabled
                          }
                        >
                          <i className="fab fa-facebook fb social-icons" />{" "}
                          {t("login_with")} {t("facebook")}
                        </button>
                      )}
                    />
                  ) : null}
                </div>
                <div>
                  {(this.state.googleClientId || getGooglePublicClientId()) ? (
                    <GoogleSignInButton
                      label={t("login_with") + " " + t("google")}
                      onDecoded={this.responseGoogle}
                      onError={this.responseGoogleError}
                      disabled={this.state.buttonDisable}
                    />
                  ) : null}
                </div>

                <p className="auth-link">
                  <span className="grey-text">{t("new_to_website")}{" "}</span>
                  <Link to={"/register"} className="btn-link">
                    {t("sign_up_now")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </DestinationExperienceGate>
    );
  }
}

export default withToastManager(translate(LoginCommponent));
